import styled from 'styled-components';

export const SkeletonPage = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const SkeletonHeader = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SkeletonSurface = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  border: 1px solid ${props => props.theme.palette.colors.border};
  border-radius: 11px;
  background: ${props => props.theme.palette.colors.white};
`;
